<div class='margin-b-25'>
  <div
    class='padding-l-20 padding-b-10 shaded-widget-bg'
    style='border-top-left-radius: 6px; border-top-right-radius: 6px'
  >
    <div class='padding-b-10' fxLayout='row wrap'>
      <h2
        class='margin-non'
        style='transform: translate(0px, 11px)'
        [innerHTML]="
					roadRiskWithRegTrademark +
					' ' +
					riskProfileName +
					': ' +
					cService.readyTranslations.generic.riskRating +
					':'
				"
      ></h2>

      <div style='transform: translate(10px, 16px)' fxFlex>
        <h2 class='margin-non' *ngIf='roadRiskInfo.rating === riskRatings.low'>
          {{ 'REPORTDATA.low' | translate }}
        </h2>
        <h2 class='margin-non' *ngIf='roadRiskInfo.rating === riskRatings.medium'>
          {{ 'REPORTDATA.medium' | translate }}
        </h2>
        <h2 class='margin-non' *ngIf='roadRiskInfo.rating === riskRatings.high'>
          {{ 'REPORTDATA.high' | translate }}
        </h2>
        <h2 class='margin-non' *ngIf='roadRiskInfo.rating === riskRatings.veryHigh'>
          {{ 'REPORTDATA.veryHigh' | translate }}
        </h2>
      </div>

      <div class='padding-r-20'>
        <risk-rating-indicator
          indicatorWidth='300px'
          [activeBarColor]='riskRatingColors[roadRiskInfo.rating]'
        ></risk-rating-indicator>
      </div>
    </div>

    <small class='bold'>{{ 'REPORTDATA.dateCompleted' | translate }}: {{ roadRiskInfo.dateCompleted }}</small>
  </div>

  <!-- Question & Answers -->
  <div *ngFor='let question of roadRiskInfo.questions'>
    <vrm-expansion-panel formStyleBorderColor='#e4e4e4' formStyleBorderWidth='1px'>
      <div header fxFlex>
        <div *ngIf='question.rating || question.score; else unknownValuation'>
          <div *ngIf='question.rating && !question.score' fxLayout='row' fxFlex fxLayoutAlign='space-between'>
            <div fxFlex>
              {{
              cService.readyTranslations.reportColumns[question.name + ' ' + 'Risk Rating']
                ? cService.readyTranslations.reportColumns[question.name + ' ' + 'Risk Rating']
                : question.name + ' ' + 'Risk Rating'
              }}
            </div>

            <div *ngIf='question.rating === riskRatings.veryHigh' class='red-text'>
              {{ 'REPORTDATA.veryHigh' | translate }}
            </div>
            <div *ngIf='question.rating === riskRatings.high' class='red-text'>
              {{ 'REPORTDATA.high' | translate }}
            </div>
            <div *ngIf='question.rating === riskRatings.medium' class='amber-text'>
              {{ 'REPORTDATA.medium' | translate }}
            </div>
            <div *ngIf='question.rating === riskRatings.low' class='green-text'>
              {{ 'REPORTDATA.low' | translate }}
            </div>
          </div>

          <div *ngIf='question.score' fxLayout='row' fxFlex fxLayoutAlign='space-between'>
            <div fxFlex>
              {{
              cService.readyTranslations.reportColumns[question.name + ' ' + 'Score']
                ? cService.readyTranslations.reportColumns[question.name + ' ' + 'Score']
                : question.name + ' ' + 'Score'
              }}
            </div>

            <div *ngIf='question.rating === riskRatings.veryHigh' class='red-text'>
              {{ question.score + '%' }}
            </div>
            <div *ngIf='question.rating === riskRatings.high' class='red-text'>
              {{ question.score + '%' }}
            </div>
            <div *ngIf='question.rating === riskRatings.medium' class='amber-text'>
              {{ question.score + '%' }}
            </div>
            <div *ngIf='question.rating === riskRatings.low' class='green-text'>
              {{ question.score + '%' }}
            </div>
          </div>
        </div>
        <ng-template #unknownValuation>
          <div>
            {{
            cService.readyTranslations.reportColumns[question.name]
              ? cService.readyTranslations.reportColumns[question.name]
              : question.name
            }}
          </div>
        </ng-template>
      </div>

      <!-- Answers -->
      <div style='padding: 20px' fxLayout='column'>
        <!-- Card Q&A -->
        <div fxLayout='row wrap' style='border-top: 1px solid #cccccc70; border-left: 1px solid #cccccc70'>
          <insight-action-card
            cardHeight='180px'
            fxFlex
            *ngFor='let qAndA of question.answers'
            [cardHeadline]='qAndA.question'
            headlineFontSize='16px'
            [cardSubHeadline]='qAndA.answer'
            subHeadlineFontSize='14px'
            [subHeadlineColor]='riskRatingColors[qAndA.rating]'
            [cardBodyText]='qAndA.description'
            contentMinWidth='250px'
          ></insight-action-card>
        </div>
      </div>
    </vrm-expansion-panel>
  </div>
</div>
